/* eslint-disable max-len */
import { BrowserRouter as Router, Link } from 'react-router-dom';
import './home.scss';
import Contact from '../Contact';

const anneeActuelle = new Date().getFullYear();
const moisActuel = new Date().getMonth() + 1;
const jourActuel = new Date().getDate();
const moisNaissance = 5;
const jourNaissance = 13;
const anneeNaissance = 1997;
let age;
if (moisActuel > moisNaissance || (moisActuel === moisNaissance && jourActuel >= jourNaissance)) {
    age = anneeActuelle - anneeNaissance;
} else {
    age = anneeActuelle - anneeNaissance - 1;
}

const Home = () => (
    <main className="home">
        <section className="home-presentation">
            <h1 className="home-title-name">Guillaume Sanchez</h1>
            <h2 className="home-welcome">Bienvenue sur ma Page Professionnelle 👋</h2>
            <p className="home-intro">
                Moi c'est Guillaume, {age} ans, passionné d'Informatique !
            </p>
            <p className="home-intro">
                Mon parcours se construit autour d'une vision globale du système d'information : du code applicatif jusqu'à l'infrastructure qui l'héberge.
            </p>
            <p className="home-intro">
                Après une formation initiale de Développement Web avec l'école{' '}
                <strong>
                    <a href="https://oclock.io/" target="_blank" rel="noopener noreferrer">O'Clock</a>
                </strong>, 
                j'ai évolué vers l'opérationnel en tant qu'<strong>Exploitant Applicatif et Système</strong> au sein de la DISI Île-de-France. <br/>
                Depuis 2021, j'y assure le maintien en condition opérationnelle, l'administration d'environnements Linux (RedHat, Rocky) et l'automatisation via des scripts Shell.
            </p>
            <p className="home-intro">
                Aujourd'hui, j'oriente mon expertise vers la protection des infrastructures. Je poursuis actuellement un{' '}
                <strong>Master Management en Ingénierie Informatique, spécialisation Cybersécurité</strong> à{' '}
                <strong>
                    <a href="https://www.utec77.fr/" target="_blank" rel="noopener noreferrer">l'UTEC de Melun</a>
                </strong>, 
                tout en maintenant mon poste à la DISI.<br/>
                Cette double casquette me permet d'anticiper les risques de sécurité tout en comprenant les contraintes réelles de l'administration système.
            </p>
            <p className="home-cta-container">
                Vous pouvez jeter un oeil à mon <a href="./Curriculum-vitae-Guillaume-Sanchez.pdf" download="./Curriculum-vitae-Guillaume-Sanchez.pdf" className="btn-download-cv">CV</a> 📥
            </p>
        </section>
        <Contact />
    </main>
);

export default Home;
